import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/reports')({
  component: () => {
    return (
      <div>
        <Outlet />
      </div>
    );
  },
});
